import {
  IonGrid,
  IonRow,
  IonCol,
  IonListHeader,
  IonList,
  IonItem,
  IonContent,
  IonPopover,
} from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Spacer from "../../../../components/spacer";
import { getEntries } from "../../../../services/users";
import CalendarKey from "./CalendarKey";
import DueNowEntryList from "./DueNowEntryList";
import OverDueEntriesList from "./OverDueEntriesList";
import UserHeader from "./UserHeader";
import UserPhaseList from "./UserPhaseList";

interface props {
  user: any;
  userDetails: any;
}

const UserDashboard: React.FC<props> = ({ user, userDetails }) => {
  const history = useHistory();

  const [dates, setDates] = useState<any>([]);
  const [entries, setEntries] = useState<any>([]);
  const [value, onChange] = useState(new Date());
  const [overdueDates, setOverdueDates] = useState<any>([]);

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const onClickDay = (date: any) => {
    let dateTS = new Date(date).getTime();
    if (dates[dateTS] && dates[dateTS].status !== "upcoming") {
      history.push(`/users/${user.uid}/date/${dateTS}`);
    }
    if (dates[dateTS] && dates[dateTS].status === "upcoming") {
      setPopoverOpen(true);
    }
  };

  /**
   * Create an array of objects which represent dates within phases and whether an entry is required
   */
  const _createUserDates = () => {
    let res: any = [];
    let today = new Date().getTime();
    //console.log(user.dates);

    Object.values(user.dates).forEach((element: any) => {
      let status = "upcoming";
      // if (element.timestamp === 1664100000000) debugger;
      let dateTS = element.timestamp.toString();

      if (dateTS <= today) {
        //console.log("day has passed");
        // if entries contains an object with the dateTS as TS
        let validEntries = Object.values(entries).filter(
          (entry: any) => entry.dateTS === dateTS
        );

        // if (validEntries.length > 1) {
        //   console.log(validEntries);
        // }

        status = "overdue";

        validEntries.forEach((el: any) => {
          if (el.complete) {
            // if(user.study === "toilet"){
            // 	if(el.entryType === "regular") status = "complete";
            // } else
            status = "complete";
          } else {
            if (status === "overdue") {
              status = "incomplete";
            }
          }
        });
      }

      res[dateTS] = {
        ...element,
        status,
      };
      //console.log(res[dateTS]);
    });
    // console.log(res);

    setDates(res);
  };

  useEffect(() => {
    //console.log(user);
    getEntries(user.uid).then((data: any) => {
      setEntries(data);
    });
  }, [user]);

  useEffect(() => {
    if (user.dates) {
      _createUserDates();
    }
    //eslint-disable-next-line
  }, [entries]);

  useEffect(() => {
    // if (user.dates) {
    // 	_createUserDates();
    // }
    // console.log(user);
    //console.log(dates);
    //eslint-disable-next-line
  }, [dates]);

  useEffect(() => {
    //console.log(dates);
    if (dates) {
      let overdue = Object.values(dates).filter(
        (date: any) => date.status === "overdue" || date.status === "incomplete"
      );
      setOverdueDates(overdue);
    }
  }, [dates]);

  const getDateClass = (activeStartDate: any, day: any, view: any) => {
    let response = "";
    if (view === "month") {
      let dateTS = new Date(day).getTime();
      //console.log(dateTS);
      //console.log(new Date(day));
      let data = dates[dateTS];
      //console.log(data);
      if (data) {
        switch (data.status) {
          case "complete":
            return "entry-complete";
          case "overdue":
            return "entry-due";
          case "incomplete":
            return "entry-incomplete";
          case "upcoming":
            return "entry-upcoming";
          default:
            break;
        }
      }
    }
    return response;
  };

  return (
    <>
      <IonPopover
        ref={popover}
        isOpen={popoverOpen}
        onDidDismiss={() => setPopoverOpen(false)}
      >
        <IonContent class="ion-padding">
          You can not add an entry to a date in the future
        </IonContent>
      </IonPopover>
      <UserHeader user={user} isAdmin={userDetails.isAdmin} />
      <IonGrid>
        <IonRow>
          <IonCol>
            <IonList>
              <IonListHeader mode="ios">Your Calendar</IonListHeader>
              <IonItem lines="none">
                <div className="calendar">
                  <div className="calendar__container">
                    <main className="calendar__container__content">
                      {Object.values(dates).length > 0 && (
                        <Calendar
                          onChange={onChange}
                          onClickDay={onClickDay}
                          value={value}
                          className="userDashCal"
                          tileClassName={({ activeStartDate, date, view }) =>
                            getDateClass(activeStartDate, date, view)
                          }
                        />
                      )}
                      <CalendarKey />
                    </main>
                  </div>
                </div>
              </IonItem>
            </IonList>
          </IonCol>
          <IonCol>
            <IonList>
              <IonListHeader mode="ios">Overdue</IonListHeader>
              <OverDueEntriesList user={user} dates={overdueDates} />
            </IonList>
            <Spacer size="60" />
            <IonList>
              <IonListHeader mode="ios">Due Now</IonListHeader>
              <DueNowEntryList user={user} dates={overdueDates} />
            </IonList>
            <Spacer size="60" />
          </IonCol>
          <IonCol sizeLg="4" sizeSm="6" sizeXs="12">
            <IonList>
              <IonListHeader mode="ios">Phases</IonListHeader>
              <UserPhaseList user={user} entries={entries} />
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  userDetails: state.user.userDetails,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserDashboard);
